import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('bienvenida')}>
            <img 
              src="https://static.readdy.ai/image/f0504b97139bc354dc5720a1b109b5af/0617c5e7d9074a8be697d2f0e79bec75.png" 
              alt="UNAM Logo" 
              className="h-12 w-auto"
            />
            <div>
              <h1 className={`text-xl font-bold transition-colors ${
                isScrolled ? 'text-[#1b3d70]' : 'text-white'
              }`}>Speed Mentoring</h1>
              <p className={`text-sm transition-colors ${
                isScrolled ? 'text-[#bb8800]' : 'text-white/90'
              }`}>UNAM</p>
            </div>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8">
            <button 
              onClick={() => scrollToSection('bienvenida')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#bb8800]' : 'text-white hover:text-[#bb8800]'
              }`}
            >
              Inicio
            </button>
            <button 
              onClick={() => scrollToSection('como-funciona')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#bb8800]' : 'text-white hover:text-[#bb8800]'
              }`}
            >
              Cómo Funciona
            </button>
            <button 
              onClick={() => scrollToSection('importancia')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#bb8800]' : 'text-white hover:text-[#bb8800]'
              }`}
            >
              Importancia
            </button>
            <button 
              onClick={() => scrollToSection('mentores')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#bb8800]' : 'text-white hover:text-[#bb8800]'
              }`}
            >
              Mentores
            </button>
            <button 
              onClick={() => scrollToSection('registro')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#bb8800]' : 'text-white hover:text-[#bb8800]'
              }`}
            >
              Registro
            </button>
            <button 
              onClick={() => scrollToSection('registro')}
              className="bg-[#bb8800] text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-[#996d00] transition-colors whitespace-nowrap cursor-pointer"
            >
              Regístrate
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-[#1b3d70]' : 'text-white'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200 py-4">
            <button 
              onClick={() => scrollToSection('bienvenida')}
              className="block w-full text-left px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50 cursor-pointer"
            >
              Inicio
            </button>
            <button 
              onClick={() => scrollToSection('como-funciona')}
              className="block w-full text-left px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50 cursor-pointer"
            >
              Cómo Funciona
            </button>
            <button 
              onClick={() => scrollToSection('importancia')}
              className="block w-full text-left px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50 cursor-pointer"
            >
              Importancia
            </button>
            <button 
              onClick={() => scrollToSection('mentores')}
              className="block w-full text-left px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50 cursor-pointer"
            >
              Mentores
            </button>
            <button 
              onClick={() => scrollToSection('registro')}
              className="block w-full text-left px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50 cursor-pointer"
            >
              Registro
            </button>
            <div className="px-4 pt-2">
              <button 
                onClick={() => scrollToSection('registro')}
                className="w-full bg-[#bb8800] text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-[#996d00] transition-colors whitespace-nowrap cursor-pointer"
              >
                Regístrate
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}